export const dataEhMaior = (data1, data2) => {
  const dt1 = new Date(data1)
  const dt2 = new Date(data2)

  return dt1 > dt2
}

export const dataEhMenor = (data1, data2) => {
  const dt1 = new Date(data1)
  const dt2 = new Date(data2)

  return dt1 < dt2
}

export const paraDate = dataString => new Date(dataString)

export const retornaStringDataParaDDMMYYYY = dataString => `${dataString.substring(8, 10)}/${dataString.substring(5, 7)}/${dataString.substring(0, 4)}`
